import { t as __decorate } from "../../chunk-decorate.mjs";
import { Trigger, asyncTimeout } from "@dxos/async";
import { log, logInfo } from "@dxos/log";
import { RESOURCE_LOCK_TIMEOUT } from "@dxos/client-protocol";
//#region src/packlets/locks/browser.ts
var __dxlog_file = "/__w/dxos/dxos/packages/sdk/client-services/src/packlets/locks/browser.ts";
var Lock = class {
	_broadcastChannel = new BroadcastChannel("vault-resource-lock");
	_lockKey;
	_onAcquire;
	_onRelease;
	_releaseTrigger = new Trigger();
	constructor({ lockKey, onAcquire, onRelease }) {
		this._lockKey = lockKey;
		this._onAcquire = onAcquire;
		this._onRelease = onRelease;
		this._broadcastChannel.onmessage = this._onMessage.bind(this);
	}
	get lockKey() {
		return this._lockKey;
	}
	async acquire() {
		this._broadcastChannel.postMessage({ message: "acquiring" });
		try {
			log("aquiring lock...", void 0, {
				"~LogMeta": "~LogMeta",
				F: __dxlog_file,
				L: 42,
				S: this
			});
			await asyncTimeout(this._requestLock(), RESOURCE_LOCK_TIMEOUT);
			log("acquired lock", void 0, {
				"~LogMeta": "~LogMeta",
				F: __dxlog_file,
				L: 44,
				S: this
			});
		} catch {
			log("stealing lock...", void 0, {
				"~LogMeta": "~LogMeta",
				F: __dxlog_file,
				L: 46,
				S: this
			});
			await this._requestLock(true);
			log("stolen lock", void 0, {
				"~LogMeta": "~LogMeta",
				F: __dxlog_file,
				L: 48,
				S: this
			});
		}
	}
	async release() {
		this._releaseTrigger.wake();
	}
	_onMessage(event) {
		if (event.data.message === "acquiring") this._releaseTrigger.wake();
	}
	async _requestLock(steal = false) {
		log("requesting lock...", { steal }, {
			"~LogMeta": "~LogMeta",
			F: __dxlog_file,
			L: 63,
			S: this
		});
		const acquired = new Trigger();
		navigator.locks.request(this._lockKey, { steal }, async () => {
			await this._onAcquire?.();
			acquired.wake();
			this._releaseTrigger = new Trigger();
			await this._releaseTrigger.wait();
			log("releasing lock...", void 0, {
				"~LogMeta": "~LogMeta",
				F: __dxlog_file,
				L: 72,
				S: this
			});
			await this._onRelease?.();
			log("released lock", void 0, {
				"~LogMeta": "~LogMeta",
				F: __dxlog_file,
				L: 74,
				S: this
			});
		}).catch(async () => {
			await this._onRelease?.();
		});
		await acquired.wait();
		log("recieved lock", { steal }, {
			"~LogMeta": "~LogMeta",
			F: __dxlog_file,
			L: 81,
			S: this
		});
	}
};
__decorate([logInfo], Lock.prototype, "lockKey", null);
var isLocked = (lockPath) => {
	throw new Error("Not implemented");
};
//#endregion
export { Lock, isLocked };

//# sourceMappingURL=browser.mjs.map